import { all, call, put, takeLatest } from 'redux-saga/effects';
import { get, find, map, set, isEmpty } from 'lodash-es';

import {
  fetchSalesRoutesSuccess,
  fetchSalesRoutesFail,
  fetchSalesRouteSuccess,
  fetchSalesRouteFail,
  createSalesRouteSuccess,
  createSalesRouteFail,
  updateSalesRouteSuccess,
  updateSalesRouteFail,
  patchSalesRouteSuccess,
  patchSalesRouteFail,
  fetchQuestionnaireSuccess,
  fetchQuestionnaireFail,
  // fetchRelations
  fetchRelations,
  fetchRelationsSuccess,
  fetchRelationsFail,
  // fetchQuestionnaires
  fetchQuestionnaires,
  fetchQuestionnairesSuccess,
  fetchQuestionnairesFail,
  // partialUpdateSalesRoute
  partialUpdateSalesRouteAnswersSuccess,
  partialUpdateSalesRouteAnswersFail,
  partialUpdateSalesRouteLoansSuccess,
  partialUpdateSalesRouteLoansFail,
  partialUpdateSalesRouteQuotationsSuccess,
  partialUpdateSalesRouteQuotationsFail,
  partialUpdateSalesRouteExtraDataSuccess,
  partialUpdateSalesRouteExtraDataFail,
  partialUpdateSalesRouteGeneralDataSuccess,
  partialUpdateSalesRouteGeneralDataFail,
  partialUpdateSalesRouteContractSuccess,
  partialUpdateSalesRouteContractFail,
  partialUpdateSalesRouteContractPrintSuccess,
  partialUpdateSalesRouteContractPrintFail,
  partialUpdateSalesRouteSubscriptionSuccess,
  partialUpdateSalesRouteSubscriptionFail,
  // computeQuestionnaire
  computeQuestionnaireSuccess,
  computeQuestionnaireFail,
  // fetchQuotationDescriptions
  fetchQuotationDescriptionsSuccess,
  fetchQuotationDescriptionsFail,
  // simulateQuotations
  simulateQuotationsSuccess,
  simulateQuotationsFail,
  // subscribeContracts
  subscribeContracts,
  subscribeContractsSuccess,
  subscribeContractsFail,
  fetchProductDescriptions,
  fetchProductDescriptionsSuccess,
  fetchProductDescriptionsFail,
  // putOnHoldSalesRoute,
  putOnHoldSalesRouteSuccess,
  putOnHoldSalesRouteFail,
  // cancelSalesRoute
  cancelSalesRouteSuccess,
  cancelSalesRouteFail,
  // printSalesRouteUrl
  printSalesRoute,
  printSalesRouteSuccess,
  printSalesRouteFail,
  // extendSalesroutes
  extendSalesroutes,
  extendSalesroutesSuccess,
  extendSalesroutesFail,
  //
  quotationBlockChangeFieldSuccess,
  quotationBlockChangeFieldFail,
} from './actions';

import {
  FETCH_RELATIONS_REQUEST,
  FETCH_QUESTIONNAIRES_REQUEST,
  FETCH_QUESTIONNAIRE_REQUEST,
  FETCH_SALESROUTES_REQUEST,
  FETCH_SALESROUTE_REQUEST,
  CREATE_SALESROUTE_REQUEST,
  UPDATE_SALESROUTE_REQUEST,
  PATCH_SALESROUTE_REQUEST,
  PARTIAL_UPDATE_SALESROUTE_ANSWERS_REQUEST,
  PARTIAL_UPDATE_SALESROUTE_LOANS_REQUEST,
  PARTIAL_UPDATE_SALESROUTE_EXTRADATA_REQUEST,
  PARTIAL_UPDATE_SALESROUTE_GENERALDATA_REQUEST,
  PARTIAL_UPDATE_SALESROUTE_CONTRACT_REQUEST,
  PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_REQUEST,
  PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_REQUEST,
  COMPUTE_QUESTIONNAIRES_REQUEST,
  FETCH_QUOTATION_DESCRIPTIONS_REQUEST,
  PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_REQUEST,
  SIMULATE_QUOTATIONS_REQUEST,
  SUBSCRIBE_CONTRACTS_REQUEST,
  FETCH_PRODUCT_DESCRIPTIONS_REQUEST,
  PUTONHOLD_SALESROUTE_REQUEST,
  CANCEL_SALESROUTE_REQUEST,
  PRINT_SALESROUTE_REQUEST,
  EXTEND_SALESROUTES_REQUEST,
  QUOTATIONBLOCK_CHANGE_FIELD_REQUEST,
} from './actionTypes';

import { statusSalesRouteEnum } from './enum';

import { logout } from '../Auth/actions';
import { getOptions, processResponse } from '../../Utils/Utils';
import { API, fetchFromApi } from '../apis';

const { CLOSED, INPROGRESS, ONHOLD } = statusSalesRouteEnum;

/**
 * fetch Quotation Descriptions
 * @param {*} param0
 */
function* fetchQuotationDescriptions({ id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.ACTION__DESCRIBE_QUOTATION__BY_ID(id), method: 'POST' })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(fetchQuotationDescriptionsSuccess({ data, id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(fetchQuotationDescriptionsFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * compute Questionnaire
 * @param {*} param0
 */
function* computeQuestionnaire({ id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.ACTION__COMPUTE_QUESTIONNAIRE__BY_ID(id), method: 'POST' })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(computeQuestionnaireSuccess({ data, id: get(data, '_id') }));
      // call fetchQuotationDescriptions
      yield* fetchQuotationDescriptions({ id: get(data, '_id') });
      break;
    case 'fail':
    case 'forbidden':
      yield put(computeQuestionnaireFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * simulate Quotations
 * @param {*} param0
 */
function* simulateQuotations({ id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.ACTION__SIMULATE_QUOTATIONS__BY_ID(id), method: 'POST' })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(simulateQuotationsSuccess({ data, id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(simulateQuotationsFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * Subscribe Contracts
 * @param {*} param0
 */
function* subscribeContractsSagas({ id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.ACTION__SUBSCRIBE_CONTRACTS_BY_ID(id), method: 'POST' })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(subscribeContractsSuccess({ data, id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(subscribeContractsFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * print SalesRoute
 * @param {*} param0
 */
function* printSalesRouteSagas({ id }) {
  const payload = {
    documents: [{ code: 'BA' }, { code: 'FC' }, { code: 'DEVIS' }],
  };
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.ACTION__PRINT_SALESROUTE__BY_ID(id), method: 'POST', data: payload })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(printSalesRouteSuccess({ data, id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(printSalesRouteFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * Partial update sales route 'Contract' then print
 * @param {*} param0
 */
function* partialUpdateSalesRouteContractPrint({ payload, id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.ACTION__GENERATE_CONTRACTS__BY_ID(id), method: 'POST', data: { ...payload } })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(partialUpdateSalesRouteContractPrintSuccess({ data, id: get(data, '_id') }));
      // print salesroute
      yield put(printSalesRoute({ id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(partialUpdateSalesRouteContractPrintFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * Partial update sales route 'Contract'
 * @param {*} param0
 */
function* partialUpdateSalesRouteContract({ id, payload }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.ACTION__GENERATE_CONTRACTS__BY_ID(id), method: 'POST', data: { ...payload } })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(partialUpdateSalesRouteContractSuccess({ data, id }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(partialUpdateSalesRouteContractFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * Partial update sales route 'Subscription'
 * @param {*} param0
 */
function* partialUpdateSalesRouteSubscription({ id, payload }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.PATCH__BY_ID(id), method: 'PATCH', data: { ...payload } })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(partialUpdateSalesRouteSubscriptionSuccess({ data, id }));
      yield put(subscribeContracts({ id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(partialUpdateSalesRouteSubscriptionFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * Partial update sales route 'Quotations'
 * @param {*} param0
 */
function* partialUpdateSalesRouteQuotations({ payload, id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.PATCH__BY_ID(id), method: 'PATCH', data: { ...payload, status: INPROGRESS } })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(partialUpdateSalesRouteQuotationsSuccess({ data, id: get(data, '_id') }));
      // call simulateQuotations
      yield* simulateQuotations({ id: get(data, '_id') });
      break;
    case 'fail':
    case 'forbidden':
      yield put(partialUpdateSalesRouteQuotationsFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * fetch product descriptions
 */
function* fetchProductDescriptionsSagas({ idSalesRoute }) {
  const params = {};
  const { response, error } = yield call(fetchFromApi, getOptions({ url: API.product.FETCH__ALL(), params }));
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(fetchProductDescriptionsSuccess({ idSalesRoute, data }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(fetchProductDescriptionsFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* fetchQuestionnairesBySalesrouteIdSaga({ idSalesRoute }) {
  const params = {};
  const { response, error } = yield call(fetchFromApi, getOptions({ url: API.questionnaire.FETCH__ALL(), params }));
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(fetchQuestionnairesSuccess({ idSalesRoute, data }));
      // call products = dispatch action
      yield put(fetchProductDescriptions({ idSalesRoute }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(fetchQuestionnairesFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* fetchQuestionnairesSaga() {
  const params = {};
  const { response, error } = yield call(fetchFromApi, getOptions({ url: API.questionnaire.FETCH__ALL(), params }));
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(extendSalesroutesSuccess({ data }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(extendSalesroutesFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* fetchRelationsSaga({ idSalesRoute }) {
  const params = {};
  const { response, error } = yield call(fetchFromApi, getOptions({ url: API.parties.FETCH__RELATIONS(), params }));
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(fetchRelationsSuccess({ data }));
      // call fetchQuestionnaires
      yield put(fetchQuestionnaires({ idSalesRoute }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(fetchRelationsFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * Partial update sales route 'Answers'
 * @param {*} param0
 */
function* partialUpdateSalesRouteAnswers({ payload, id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.PATCH__BY_ID(id), method: 'PATCH', data: { ...payload, status: INPROGRESS } })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(partialUpdateSalesRouteAnswersSuccess({ data, id: get(data, '_id') }));
      // call computeQuestionnaire
      yield* computeQuestionnaire({ id: get(data, '_id') });
      break;
    case 'fail':
    case 'forbidden':
      yield put(partialUpdateSalesRouteAnswersFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * Partial update sales route 'Loans'
 * @param {*} param0
 */
function* partialUpdateSalesRouteLoans({ payload, id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.PATCH__BY_ID(id), method: 'PATCH', data: { ...payload } })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(partialUpdateSalesRouteLoansSuccess({ data, id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(partialUpdateSalesRouteLoansFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * Partial update sales route 'Extra Data Contract'
 * @param {*} param0
 */
function* partialUpdateSalesRouteExtraData({ payload, id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.PATCH__BY_ID(id), method: 'PATCH', data: { ...payload } })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(partialUpdateSalesRouteExtraDataSuccess({ data, id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(partialUpdateSalesRouteExtraDataFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * Partial update sales route 'General Data'
 * @param {*} param0
 */
function* partialUpdateSalesRouteGeneralData({ payload, id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.PATCH__BY_ID(id), method: 'PATCH', data: { ...payload } })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(partialUpdateSalesRouteGeneralDataSuccess({ data, id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(partialUpdateSalesRouteGeneralDataFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* fetchQuestionnaire({ id }) {
  const params = {};
  const { response, error } = yield call(fetchFromApi, getOptions({ url: API.questionnaire.FETCH__BY_ID(id), params }));
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(fetchQuestionnaireSuccess({ data }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(fetchQuestionnaireFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* fetchSalesRoutes() {
  const params = {
    mask: encodeURI('b2b'),
    kind: encodeURI('salesroute'),
  };
  const { response, error } = yield call(fetchFromApi, getOptions({ url: API.salesroute.FETCH__ALL(), params }));
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(fetchSalesRoutesSuccess({ data }));
      // call fetchQuestionnaires
      yield put(extendSalesroutes({}));
      break;
    case 'fail':
    case 'forbidden':
      yield put(fetchSalesRoutesFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* fetchSalesRoute({ id }) {
  const payload = { questionnaire: id };
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.FETCH__BY_ID(id), method: 'GET', data: payload })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(fetchSalesRouteSuccess({ data, id }));
      // call fetchRelations
      yield put(fetchRelations({ idSalesRoute: id }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(fetchSalesRouteFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* createSalesRoute({ payload, history }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.ACTION__CREATE_SALESROUTE(), method: 'POST', data: payload })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      const id = get(data, '_id');
      yield put(createSalesRouteSuccess({ data, id }));
      if (history) history.push(`/salesroutes/${id}`);
      break;
    case 'fail':
    case 'forbidden':
      yield put(createSalesRouteFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * update a SalesRoute
 * @param {*} param0
 */
function* updateSalesRoute({ id, payload }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.UPDATE__BY_ID(id), method: 'POST', data: payload })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(updateSalesRouteSuccess({ data, id }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(updateSalesRouteFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * Patch a SalesRoute
 * @param {*} param0
 */
function* patchSalesRoute({ id, payload }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.PATCH__BY_ID(id), method: 'PATCH', data: payload })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(patchSalesRouteSuccess({ data, id }));
      break;
    case 'fail':
      yield put(patchSalesRouteFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * put on hold a SalesRoute
 * @param {*} param0
 */
function* putOnHoldSalesRoute({ id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.PATCH__BY_ID(id), method: 'PATCH', data: { status: ONHOLD } })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(putOnHoldSalesRouteSuccess({ data, id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(putOnHoldSalesRouteFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * cancel a SalesRoute
 * @param {*} param0
 */
function* cancelSalesRoute({ id }) {
  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: API.salesroute.PATCH__BY_ID(id), method: 'PATCH', data: { status: CLOSED } })
  );
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(cancelSalesRouteSuccess({ data, id: get(data, '_id') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(cancelSalesRouteFail({ error: alerts, id }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

/**
 * get ChangeField
 * @param {*} param0
 */
function* getChangeField({ code = '', answers = [] }) {
  try {
    // find object
    const findObject = (array, codeTarget) => {
      try {
        const result = find(array, item => {
          if (get(item, 'code').includes(codeTarget)) {
            return true;
          }
          return false;
        });
        return result;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`findObject: ${e.stack}`);
      }
      return {};
    };
    // calculate gross salary
    const calculateGrossSalary = increasedIndex => {
      try {
        const VALEUR_POINT = 5625.23;
        const resultGrossSalary = (increasedIndex * VALEUR_POINT) / 100 / 12;
        return resultGrossSalary.toFixed(2);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`calculateGrossSalary: ${e.stack}`);
      }
      return 0;
    };
    // get Gross salary
    const getGrossSalary = allAnswers => {
      try {
        let result = {};
        const increasedIndexObject = findObject(allAnswers, 'increased_index');
        const grossSalaryObject = findObject(allAnswers, 'gross_salary');
        const grossSalaryCode = get(grossSalaryObject, 'code');
        const increasedIndexValue = Number(get(increasedIndexObject, 'value'));

        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(increasedIndexValue) && !isEmpty(get(increasedIndexObject, 'value'))) {
          result = { code: grossSalaryCode, value: calculateGrossSalary(increasedIndexValue) };
        }
        return result;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`getGrossSalary: ${e.stack}`);
      }
      return {};
    };
    //  get increased indexx
    const getIncreasedIndex = allAnswers => {
      try {
        let result = {};
        const increasedIndexObject = findObject(allAnswers, 'increased_index');
        const grossSalaryObject = findObject(allAnswers, 'gross_salary');
        //
        const grossSalaryValue = get(grossSalaryObject, 'value');
        const increasedIndexCode = get(increasedIndexObject, 'code');
        const increasedIndexValue = Number(get(increasedIndexObject, 'value'));
        //
        const grossSalaryValueCalculate = calculateGrossSalary(increasedIndexValue);
        if (grossSalaryValueCalculate !== grossSalaryValue) {
          result = { code: increasedIndexCode, value: undefined };
          return result;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`getGrossSalary: ${e.stack}`);
      }
      return {};
    };

    const promise = yield new Promise(resolve => {
      setTimeout(() => {
        // init object
        const object = { type: 'fail', result: {}, alerts: {} };
        // get all answers []
        const allAnswers = map(answers, item => get(item, 'answers')).flat();

        if (code.includes('increased_index')) {
          // get gross salary
          const result = getGrossSalary(allAnswers);
          if (get(result, 'code')) {
            set(object, 'type', 'success');
            set(object, 'result', result);
          }
        }

        if (code.includes('gross_salary')) {
          // get gross salary
          const result = getIncreasedIndex(allAnswers);
          if (get(result, 'code')) {
            set(object, 'type', 'success');
            set(object, 'result', result);
          }
          //
        }

        resolve(object);
      }, 500);
    });

    return promise;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`grossSalary ${e.stack}`);
  }
  return undefined;
}

function* quotationBlockChangeField({ code, answers }) {
  const { type, result, alerts } = yield getChangeField({ code, answers });

  switch (type) {
    case 'success':
      yield put(quotationBlockChangeFieldSuccess({ code: get(result, 'code'), value: get(result, 'value') }));
      break;
    case 'fail':
    case 'forbidden':
      yield put(quotationBlockChangeFieldFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* watchSalesRoutes() {
  yield all([
    yield takeLatest(FETCH_SALESROUTES_REQUEST, fetchSalesRoutes),
    yield takeLatest(FETCH_SALESROUTE_REQUEST, fetchSalesRoute),
    yield takeLatest(CREATE_SALESROUTE_REQUEST, createSalesRoute),
    yield takeLatest(UPDATE_SALESROUTE_REQUEST, updateSalesRoute),
    yield takeLatest(PATCH_SALESROUTE_REQUEST, patchSalesRoute),
    yield takeLatest(FETCH_RELATIONS_REQUEST, fetchRelationsSaga),
    yield takeLatest(FETCH_QUESTIONNAIRES_REQUEST, fetchQuestionnairesBySalesrouteIdSaga),
    yield takeLatest(FETCH_PRODUCT_DESCRIPTIONS_REQUEST, fetchProductDescriptionsSagas),
    yield takeLatest(FETCH_QUESTIONNAIRE_REQUEST, fetchQuestionnaire),
    yield takeLatest(PARTIAL_UPDATE_SALESROUTE_ANSWERS_REQUEST, partialUpdateSalesRouteAnswers),
    yield takeLatest(PARTIAL_UPDATE_SALESROUTE_LOANS_REQUEST, partialUpdateSalesRouteLoans),
    yield takeLatest(PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_REQUEST, partialUpdateSalesRouteQuotations),
    yield takeLatest(PARTIAL_UPDATE_SALESROUTE_EXTRADATA_REQUEST, partialUpdateSalesRouteExtraData),
    yield takeLatest(PARTIAL_UPDATE_SALESROUTE_GENERALDATA_REQUEST, partialUpdateSalesRouteGeneralData),
    yield takeLatest(PARTIAL_UPDATE_SALESROUTE_CONTRACT_REQUEST, partialUpdateSalesRouteContract),
    yield takeLatest(PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_REQUEST, partialUpdateSalesRouteContractPrint),
    yield takeLatest(PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_REQUEST, partialUpdateSalesRouteSubscription),
    yield takeLatest(COMPUTE_QUESTIONNAIRES_REQUEST, computeQuestionnaire),
    yield takeLatest(FETCH_QUOTATION_DESCRIPTIONS_REQUEST, fetchQuotationDescriptions),
    yield takeLatest(SIMULATE_QUOTATIONS_REQUEST, simulateQuotations),
    yield takeLatest(SUBSCRIBE_CONTRACTS_REQUEST, subscribeContractsSagas),
    yield takeLatest(PUTONHOLD_SALESROUTE_REQUEST, putOnHoldSalesRoute),
    yield takeLatest(CANCEL_SALESROUTE_REQUEST, cancelSalesRoute),
    yield takeLatest(PRINT_SALESROUTE_REQUEST, printSalesRouteSagas),
    yield takeLatest(EXTEND_SALESROUTES_REQUEST, fetchQuestionnairesSaga),
    yield takeLatest(QUOTATIONBLOCK_CHANGE_FIELD_REQUEST, quotationBlockChangeField),
  ]);
}

export default watchSalesRoutes;
